module.exports = __webpack_public_path__ + "static/media/peru-map.b95fee1c.svg";